import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitCustomZoneModel } from '@apps-common/types/portal/unit'

export const QUERY_GET_UNIT_CUSTOM_ZONE = (zoneId?: number) => ['getUnitCustomZone', zoneId].filter(Boolean)

const getUnitCustomZone = async (zoneId: number): Promise<IUnitCustomZoneModel> =>
  axios.get(`/unit/getcustomzone?zoneId=${zoneId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitCustomZone

type Props = {
  config?: QueryConfig<QueryFnType>
  zoneId: number
}

export const useGetUnitCustomZone = ({ config, zoneId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_CUSTOM_ZONE(zoneId),
    queryFn: () => getUnitCustomZone(zoneId)
  })
